import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import styles from './ContextMenu.module.css';
import { Fragment } from 'react/jsx-runtime';
import { JSX } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';

export interface ItemProps {
  onClick?: () => void;
  danger?: boolean;
  label: string;
  to?: string;
}

export interface Props {
  trigger: JSX.Element;
  items: JSX.Element[];
}

// eslint-disable-next-line react-refresh/only-export-components
function ContextMenuElement({ items, trigger }: Props) {
  if (!items.length) {
    return false;
  }

  return (
    <Menu>
      <MenuButton as={Fragment}>{trigger}</MenuButton>

      <MenuItems anchor="bottom end" className={styles.contextMenu}>
        <div>{items}</div>
      </MenuItems>
    </Menu>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
function Item({ label, danger, to, onClick }: ItemProps) {
  return (
    <MenuItem
      {...(onClick && { onClick: onClick })}
      {...(to && { to: to })}
      as={to ? Link : 'button'}
      className={classNames({
        [styles.danger]: danger,
      })}
    >
      {label}
    </MenuItem>
  );
}

export const ContextMenu = Object.assign(ContextMenuElement, {
  Item,
});
